import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { validateToken, setAuthenticated } from '../redux/reducers/auth';
import { withRouter } from 'react-router-dom';
// components
import Routes from './Routes/Routes';
import Icon from '../components/Icon/Icon';
import { ToastContainer, toast } from 'react-toastify';
// utils
import queryString from 'query-string';
import { getAuthData } from '../utils/authData';
import { responseData, toastResponseErrors } from '../utils/response';
import { getUserRedirectPath } from '../utils/authHelper';
// styles
import 'flexboxgrid';
import 'react-toastify/dist/ReactToastify.min.css';
import 'hint.css/hint.min.css';
import 'rc-switch/assets/index.css';
import '../styles/overrides/Toastify.css';

const IconClose = ({ closeToast }) => (
  <Icon type="close" onClick={closeToast} color="white" />
);

class App extends Component {
  componentWillMount() {
    const {
      location: { pathname, search },
    } = this.props;
    const query = queryString.parse(search);
    if (query['account_confirmation_success']) return;
    if (query['reset_password']) return;
    if (pathname === '/signup' && query['support']) return;
    this.loadUserByToken();
  }

  loadUserByToken = () => {
    const { validateToken, setAuthenticated, history } = this.props;
    const token = getAuthData()['access-token'];
    if (token) {
      validateToken()
        .then(({ value }) => {
          // Do some redirection here
        })
        .catch(toastResponseErrors);
    } else {
      setAuthenticated(false);
    }
  };

  render() {
    return (
      <div className="app-container">
        <Routes />
        <ToastContainer
          autoClose={5000}
          position={toast.POSITION.BOTTOM_RIGHT}
          closeButton={<IconClose />}
        />
      </div>
    );
  }
}

const enhancer = compose(
  withRouter,
  connect(null, { validateToken, setAuthenticated })
);

export default enhancer(App);



// WEBPACK FOOTER //
// ./src/containers/App.js